import { render, staticRenderFns } from "./talbe.vue?vue&type=template&id=16026266&"
import script from "./talbe.vue?vue&type=script&lang=js&"
export * from "./talbe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports